module.exports = __webpack_public_path__ + "static/media/image-logo-ruangkerja.f1811560.svg";